import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { LcscV3CredentialsInputDTORuntype, LcscV3ResponseBodyDTORuntype } from './lcscV3BackendTypes';

export const lcscV3Endpoints = {
    'GET /3rdparty/lcscv3/credentials': endpoint({
        description: 'Returns credentials for lcscv3 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: LcscV3ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/lcscv3/credentials': endpoint({
        description: 'Uploads credentials for lcscv3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: LcscV3CredentialsInputDTORuntype,
        responseBody: LcscV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/lcscv3/credentials'],
    }),
    'PATCH /3rdparty/lcscv3/credentials': endpoint({
        description: 'Updates credentials for lcscv3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: LcscV3CredentialsInputDTORuntype,
        responseBody: LcscV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/lcscv3/credentials'],
    }),
    'DELETE /3rdparty/lcscv3/credentials': endpoint({
        description: 'Deletes existing credentials for lcscv3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/lcscv3/credentials'],
    }),
};
